import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'

export default function DimensionalCompetence4Chart({
  compStyle = { height: '400px', width: '100%' },
  radarIndicator = [],
  seriesData = [],
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    // title: {
    //   text: 'Basic Radar Chart',
    // },
    // legend: {
    //   data: ['Actual Spending'],
    // },
    radar: {
      // shape: 'circle',
      indicator: radarIndicator,
    },
    series: [
      {
        type: 'radar',
        data: seriesData,
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      console.log('คลิกที่:', params)
      // onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
